import axios from 'axios';
import {BASE_URL} from './index';

const dashboard = {
    getApplications: () => axios.get(`${BASE_URL}/doctors`),
    updateStatus: (payload) => axios.put(`${BASE_URL}/status`, payload),
    getSalesPersonById: (id) => axios.get(`${BASE_URL}/users/${id}`),
    edit:(salesPersonId,doctorId) => axios.get(`${BASE_URL}/${salesPersonId}/${doctorId}`)
}
  
export default dashboard